/**
 * 자릿수 180° 회전 매핑 (RULES.md v2.1 §5.2).
 * 0, 1, 6, 8, 9 만 회전 가능. 2/3/4/5/7은 회전 불가.
 */
const ROT_DIGIT: Readonly<Record<string, string>> = {
  '0': '0',
  '1': '1',
  '6': '9',
  '8': '8',
  '9': '6',
};

/**
 * 1~100 범위의 숫자를 180° 회전.
 * 회전 불가 (글자 안 됨 / 자릿수 변동) 시 null 반환.
 */
export function rotate180(n: number): number | null {
  if (!Number.isInteger(n) || n < 1 || n > 100) return null;
  const digits = String(n);
  const rotated: string[] = [];
  for (let i = digits.length - 1; i >= 0; i--) {
    const d = digits[i] as string;
    const r = ROT_DIGIT[d];
    if (r === undefined) return null;
    rotated.push(r);
  }
  if (rotated[0] === '0') return null;
  const result = Number.parseInt(rotated.join(''), 10);
  if (result < 1 || result > 100) return null;
  return result;
}

/**
 * 한 타일을 어떤 숫자로 사용할 수 있는지 후보 목록.
 * 자기 자신 + 회전 결과 (있고 자기 자신과 다를 때).
 */
export function rotationCandidates(n: number): number[] {
  const out = new Set<number>([n]);
  const r = rotate180(n);
  if (r !== null && r !== n) out.add(r);
  return [...out];
}

export function isRotationPair(a: number, b: number): boolean {
  if (a === b) return false;
  return rotate180(a) === b;
}
